import { Phone, MapPin, Clock, Shield, Mail, Train } from "lucide-react";

var PHONE_NUMBER = "+7 (812) 313-98-98";
var PHONE_HREF = "tel:+78123139898";
var EMAIL = "info@nasha-stoma.ru";
var PRIVACY_URL = "https://nasha-stoma.ru/politika/";

var CLINICS = [
  {
    district: "Невский район",
    address: "ул. Латышских Стрелков, д. 1",
    metro: "м. Проспект Большевиков",
    org: "ООО «Наша Стоматология»",
    inn: "7811443790",
    license: "№ 78-01-005133 от 26 сентября 2014 г.",
  },
  {
    district: "Петроградский район",
    address: "Крестьянский переулок, д. 5",
    metro: "м. Горьковская",
    org: "ООО «Наша Стоматология2»",
    inn: "7813655711",
    license: "№ Л041-01148-78/00591899 от 02 августа 2022 г.",
  },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-slate-900 text-white">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-xl bg-brand-600 flex items-center justify-center flex-shrink-0">
                <span className="text-white font-bold text-sm font-heading">НС</span>
              </div>
              <span className="text-base font-semibold font-heading leading-tight">
                Центр современной стоматологии и&nbsp;челюстно&#8209;лицевой хирургии
              </span>
            </div>
            <div className="flex flex-col gap-3 mt-6">
              <a href={PHONE_HREF} data-testid="footer-phone" className="flex items-center gap-3 text-slate-300 hover:text-white transition-colors text-base">
                <Phone className="w-5 h-5 text-brand-400 flex-shrink-0" />
                {PHONE_NUMBER}
              </a>
              <a href={"mailto:" + EMAIL} data-testid="footer-email" className="flex items-center gap-3 text-slate-300 hover:text-white transition-colors text-base">
                <Mail className="w-5 h-5 text-brand-400 flex-shrink-0" />
                {EMAIL}
              </a>
              <div className="flex items-center gap-3 text-slate-300 text-base">
                <Clock className="w-5 h-5 text-brand-400 flex-shrink-0" />
                Каждый день: 9:00 — 21:00
              </div>
            </div>
          </div>

          <div className="lg:col-span-2">
            <h3 className="font-heading text-lg font-semibold mb-5">Наши клиники</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {CLINICS.map(function (clinic) {
                return (
                  <div key={clinic.inn} data-testid={"footer-clinic-" + clinic.inn} className="bg-slate-800/60 rounded-2xl p-5">
                    <p className="text-white font-semibold text-base mb-2">{clinic.district}</p>
                    <div className="flex items-start gap-2 text-slate-300 text-sm mb-1.5">
                      <MapPin className="w-4 h-4 text-brand-400 flex-shrink-0 mt-0.5" />
                      <span>{clinic.address}</span>
                    </div>
                    <div className="flex items-center gap-2 text-slate-400 text-sm mb-4">
                      <Train className="w-4 h-4 text-brand-400 flex-shrink-0" />
                      <span>{clinic.metro}</span>
                    </div>
                    <div className="border-t border-slate-700 pt-3 flex items-start gap-2 text-slate-500 text-xs">
                      <Shield className="w-3.5 h-3.5 text-brand-500 flex-shrink-0 mt-0.5" />
                      <span>
                        {clinic.org}<br />
                        ИНН: {clinic.inn}<br />
                        Лицензия {clinic.license}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-slate-800">
          <p className="text-slate-500 text-xs leading-relaxed mb-4">
            ИМЕЮТСЯ ПРОТИВОПОКАЗАНИЯ, НЕОБХОДИМА КОНСУЛЬТАЦИЯ СПЕЦИАЛИСТА.
            Данный сайт носит исключительно информационный характер и&nbsp;не является
            публичной офертой, определяемой положениями Статьи 437 Гражданского кодекса РФ.
          </p>
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
            <p className="text-slate-500 text-sm">
              &copy; {new Date().getFullYear()} Наша Стоматология. Все права защищены.
            </p>
            <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-privacy-link" className="text-slate-500 text-sm hover:text-slate-300 transition-colors underline">
              Политика конфиденциальности
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
